// Utility function to clean up location names by removing duplicates
export const cleanLocationName = (name: string): string => {
    if (!name) return '';
    
    // Handle the pattern "City - Street Address"
    if (name.includes(' - ')) {
        // Split by the dash and return just the address part
        const [, addressPart] = name.split(' - ', 2);
        return addressPart?.trim() || name;
    }
    
    // If no dash pattern, return the name as is
    return name;
};
